import { render, staticRenderFns } from "./malfunctionSearchTag.vue?vue&type=template&id=6e77f476&scoped=true"
import script from "./malfunctionSearchTag.vue?vue&type=script&lang=js"
export * from "./malfunctionSearchTag.vue?vue&type=script&lang=js"
import style0 from "./malfunctionSearchTag.vue?vue&type=style&index=0&id=6e77f476&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e77f476",
  null
  
)

export default component.exports